import { Component } from '@angular/core';
import { NavController,NavParams} from 'ionic-angular';
import { StorageService } from '../../../../providers/service/storageservice';
import { AppState } from '../../../../app/app.global';
@Component({
  selector: 'login-children-page',
  templateUrl: 'recoverpwd.html'
})
export class RecoverPasswordPage {

  timeCode:string="获取验证码";
  timeNumber:number = 60;
  telePhone:string="";
  userId:string="";
  verificationCode:string="";
  timeFlag:Boolean=true;
	private timer:any;
  constructor(public navCtrl: NavController,public global: AppState,public navParm :NavParams) {
   this.userId = navParm.data.userId;
  }

  getVerificationCode(){
    if(this.timeFlag){
      	this.timeFlag = false;
      	//let params= {"userId":this.userId,"telePhone":this.telePhone};
       // this.webService.post(BINDPHONE,params,'获取验证码').then(anyObj =>{});
      	this.timer = setInterval(()=>{
	      	if(this.timeNumber > 0){
	      		this.timeNumber--;
	  	   		this.timeCode = this.timeNumber+"s";
	      	}else{
	      		clearInterval(this.timer);
	      		this.timeNumber = 60;
	      		this.timeCode="重新获取验证码";
	      		this.timeFlag=true;
	      	}
	      },1000);
      }
  }
  verifyCode(){
  		//let params= {"userId":this.userId,"telePhone":this.telePhone,"verificationCode":this.verificationCode};
  	  //this.webService.post(VERIFYCODE,params,'验证验证码').then(anyObj =>this.handleVerifyCode(anyObj));
  	 	this.handleVerifyCode({"code":"200","msg":"绑定成功"});
  }
  handleVerifyCode(anyObj:any){
  	if(anyObj){
  		StorageService.setObj("bindPhone",this.telePhone);//绑定手机号
  	}
  }


}



// WEBPACK FOOTER //
// ./src/pages/login/account/recoverpwd/recoverpwd.ts